import { DEFAULT_LOCALE } from "./localization.constants";
import { useLocale } from "./use-locale";

export function useLocalizedHref(href: string) {
    const locale = useLocale();
    if (locale === DEFAULT_LOCALE) {
        return href;
    } else {
        return `/${locale}${href}`;
    }
}
